import React from "react";

import {ICentSampleNameDetails} from "@cent/analysis/services/models";
import sampleNameDetailsService from "@cent/services/sample-details";

import {ICentSample} from "@cent/analysis/models";
import cellTypes from "@cent/services/cell-types";
import T, {parseNumber} from "@translate/T";

export interface ISampleDetailsProps {
    id: string;
    noMeanRca?: boolean;
    cellType?: string;
    sendRequest?: boolean;
}

export interface ISampleDetailsState {
    sampleDetails?: ICentSampleNameDetails;
}

class SampleDetails extends React.PureComponent<
    ISampleDetailsProps,
    ISampleDetailsState
> {
    public readonly state: ISampleDetailsState = {};

    private unsubscribe?: () => void;

    public componentDidMount() {
        const {id, noMeanRca, cellType, sendRequest} = this.props;
        const [measurementStr, positionStr, opticalStr] = id.split("-");

        if (noMeanRca && cellType) {
            return;
        }

        if (measurementStr && positionStr && opticalStr) {
            const parsedMeasurement = parseNumber(measurementStr);
            const parsedPosition = parseNumber(positionStr);
            const parsedOptical = parseNumber(opticalStr);
            this.unsubscribe = sampleNameDetailsService.subscribe({
                updateSampleNameDetails: (
                    {measurement, position},
                    sampleDetails,
                ) => {
                    if (
                        !sampleDetails ||
                        measurement !== parsedMeasurement ||
                        position !== parsedPosition
                    ) {
                        return;
                    }
                    this.setState({sampleDetails});
                },
            });

            const model: ICentSample = {
                measurement: parsedMeasurement,
                position: parsedPosition,
                optical: parsedOptical,
            };

            sampleNameDetailsService.getBySampleId(model, sendRequest);
        }
    }

    public componentWillUnmount() {
        this.unsubscribe?.();
    }

    public render() {
        const {cellType} = this.props;
        const sampleDetails = this.state.sampleDetails;

        if (sampleDetails) {
            return (
                <div className="text-muted small text-dot-overflow">
                    {sampleDetails.meanRca && (
                        <span className="mr-1">
                            <T>Mean RCA</T> {sampleDetails.meanRca},
                        </span>
                    )}
                    <span>{cellTypes.getNamebyId(sampleDetails.cellType)}</span>
                </div>
            );
        } else if (cellType) {
            return (
                <div className="text-muted small text-dot-overflow">
                    <span>{cellType}</span>
                </div>
            );
        }

        return null;
    }
}

export default SampleDetails;
